import React, { useState } from "react";
import { CssBaseline, Container, createMuiTheme, ThemeProvider, makeStyles } from "@material-ui/core";
import { useDebouncedCallback } from "use-debounce";
import InfiniteScroll from "react-infinite-scroll-component";
import { Header } from "./Header";
import { useTweets } from "./Tweets";
import { TweetCell } from "./TweetCell";
import { LoadingCell } from "./LoadingCell";

const useStyles = makeStyles(() => ({
    tweets: {
        listStyle: "none",
        padding: 0,
    },
    tweet: {
        margin: "1em auto",
    },
}));

export function App() {
    const [keywords, setKeywords] = useState<string[]>([]);
    const debouncedSetKeywords = useDebouncedCallback(
        (keywords: string) => setKeywords(keywords.trim().split(/\s+/)),
        300
    );
    const { tweets, totalCount, hasNext, fetchNext } = useTweets(keywords);
    const theme = createMuiTheme({
        palette: {
            background: {
                default: "#c6a0e1",
            },
            text: {
                secondary: "#808080",
            },
        },
        typography: {
            fontFamily: '"Hiragino Maru Gothic ProN", Meiryo',
            fontSize: 12,
            body1: {
                lineHeight: 1.6,
            },
            subtitle1: {
                fontSize: "0.75rem",
                lineHeight: 1.25,
            },
            subtitle2: {
                fontFamily: 'Georgia, "Hiragino Mincho ProN W3"',
                fontSize: "0.75rem",
                lineHeight: 1.25,
            },
        },
    });
    const styles = useStyles();

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Header totalCount={totalCount} onChangeKeywords={debouncedSetKeywords} />
            <Container maxWidth="sm">
                <InfiniteScroll
                    dataLength={tweets.length}
                    next={fetchNext}
                    hasMore={hasNext}
                    scrollThreshold={0.9}
                    loader={<LoadingCell />}>
                    <ul className={styles.tweets}>
                        {tweets.map((tweet) => (
                            <li className={styles.tweet} key={tweet.id_str}>
                                <TweetCell tweet={tweet} />
                            </li>
                        ))}
                    </ul>
                </InfiniteScroll>
            </Container>
        </ThemeProvider>
    );
}
